import React, { useRef, useState } from "react";
import emailjs from "emailjs-com";
import "../styles/contactUs.css";

const ContactUs = () => {
  const form = useRef();
  const [statusMessage, setStatusMessage] = useState("");
  const [captchaQuestion, setCaptchaQuestion] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const [userCaptchaInput, setUserCaptchaInput] = useState("");

  // Generate a random CAPTCHA question
  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10);
    const num2 = Math.floor(Math.random() * 10);
    setCaptchaQuestion(`${num1} + ${num2}`);
    setCaptchaAnswer((num1 + num2).toString());
  };

  // Handle form submission
  const sendEmail = (e) => {
    e.preventDefault();

    // Validate CAPTCHA
    if (userCaptchaInput !== captchaAnswer) {
      setStatusMessage("Incorrect CAPTCHA. Please try again.");
      return;
    }

    emailjs
      .sendForm(
        "service_fnlndk4", //Email.js service ID
        "template_q9zbyf7", //Email.js template ID
        form.current,
        "wwAsS8H0uMp4ENYif" //Email.js public key
      )
      .then(
        (result) => {
          setStatusMessage("Message sent successfully!");
          e.target.reset();
          generateCaptcha(); // Regenerate CAPTCHA for the next submission
        },
        (error) => {
          setStatusMessage("Failed to send message. Please try again later.");
        }
      );
  };

  // Initialize CAPTCHA on component mount
  React.useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <main className="page-container">
      <section className="form-section">
        <h2 className="form-title">Contact Us</h2>
        <p className="form-subtitle">
          We'd love to hear from you! Fill out the form below and we'll get back
          to you soon.
        </p>
        <form ref={form} onSubmit={sendEmail} className="form-container">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="user_email"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Enter your message"
              rows="5"
              required
            ></textarea>
          </div>

          {/* CAPTCHA */}
          <div className="form-group">
            <label htmlFor="captcha">CAPTCHA: What is {captchaQuestion}?</label>
            <input
              type="text"
              id="captcha"
              placeholder="Enter your answer"
              value={userCaptchaInput}
              onChange={(e) => setUserCaptchaInput(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="submit-btn">
            Send Message
          </button>
          {statusMessage && <p className="status-message">{statusMessage}</p>}
        </form>
      </section>
    </main>
  );
};

export default ContactUs;
